module.exports = __webpack_public_path__ + "static/img/ap-voucher-1000.68029a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/image/ap-voucher-1000.png
// module id = n8DG
// module chunks = 0